export const INFINITE_PLAN = 37;

export const NPS_FORM_TITLE = 'A sua opinião é nosso combustível';
export const NPS_FORM_CONTENT =
  'Que tal nos ajudar a melhorar cada vez mais a sua experiência aqui no iCarros, respondendo 4 perguntinhas? :)';
export const NPS_PRIMARY_ACTION = 'Responder agora';
export const NPS_SECONDARY_ACTION = 'Deixar para depois';
export const NPS_LINK = 'https://my.inovyosurvey.com/s3/f15f95c3391f';

export const FIVE_DAYS = 1000 * 60 * 60 * 24 * 5;
export const ICON_SIZE_PROPOSAL = '32px';
export const CURRENT_TIME = Date.now();

export const SERVER_NAME_REPLACEMENT = '(server)';
